export default "__VITE_PUBLIC_ASSET__d77cb9bb__"